
import React, { Component } from "react";
import { Link } from "react-router-dom";
import EmployeeService from "../Services/EmployeeService";

class EmployeeView extends Component {

    constructor(props) {

        super(props);
        this.state = {
            emp_id: '',
            first_name: '',
            last_name: '',
            email: '',
            mobile: '',
            dob: '',
            gender: '',
            address: '',
            country: '',
            city: '',
            skills: []
        }

    }
    componentDidMount() {
        const url = window.location.href;

        // console.log(url);

        let [x, k] = url.split('=');

        EmployeeService.viewEmployee(k).then((res) => {
            // console.log(res.data);
            this.setState(res.data);
        })

    }

    render() {

        return (
            <div style={{ justifyContent: 'center', textAlign: 'center', alignItems: 'center', width: '80%', margin: 'auto' }}>
                <h2 className="text-center">Employee Details</h2>
                <div className="add-page">
                    <Link to={"/employees"}>
                        <button className="btn btn-primary" >View All</button>
                    </Link>
                </div>
                <h1>Name : {this.state.first_name} {this.state.last_name} </h1>
                <h2>
                    Id: {this.state.emp_id} <br />
                    Address: {this.state.address} <br />
                    Email: {this.state.email} <br />
                    mobile: {this.state.mobile} <br />
                    Date of Birth:{this.state.dob} <br />
                    Gender: {this.state.gender} <br />
                    Country: {this.state.country} <br />
                    City: {this.state.city} <br />
                    Skills: {this.state.skills} <br />
                </h2>

            </div >
        );
    }
}

export default EmployeeView;
